export const simplifyLatin = (text) => {
  if (!text) return '';

  const map = {
    č: 'c',
    ć: 'c',
    š: 's',
    đ: 'dj',
    ž: 'z',
    Č: 'C',
    Ć: 'C',
    Š: 'S',
    Đ: 'Dj',
    Ž: 'Z',
  };

  return text.replace(/[čćšđžČĆŠĐŽ]/g, (char) => map[char] || char);
};

export const cyrillicToLatin = (text) => {
  if (!text) return '';

  const map = {
    А: 'A',
    а: 'a',
    Б: 'B',
    б: 'b',
    В: 'V',
    в: 'v',
    Г: 'G',
    г: 'g',
    Д: 'D',
    д: 'd',
    Ђ: 'Đ',
    ђ: 'đ',
    Е: 'E',
    е: 'e',
    Ж: 'Ž',
    ж: 'ž',
    З: 'Z',
    з: 'z',
    И: 'I',
    и: 'i',
    Ј: 'J',
    ј: 'j',
    К: 'K',
    к: 'k',
    Л: 'L',
    л: 'l',
    Љ: 'Lj',
    љ: 'lj',
    М: 'M',
    м: 'm',
    Н: 'N',
    н: 'n',
    Њ: 'Nj',
    њ: 'nj',
    О: 'O',
    о: 'o',
    П: 'P',
    п: 'p',
    Р: 'R',
    р: 'r',
    С: 'S',
    с: 's',
    Т: 'T',
    т: 't',
    Ћ: 'Ć',
    ћ: 'ć',
    У: 'U',
    у: 'u',
    Ф: 'F',
    ф: 'f',
    Х: 'H',
    х: 'h',
    Ц: 'C',
    ц: 'c',
    Ч: 'Č',
    ч: 'č',
    Џ: 'Dž',
    џ: 'dž',
    Ш: 'Š',
    ш: 'š',
  };

  return text.replace(/[\u0400-\u04FF]/g, (char) => map[char] || char);
};
